<script lang="ts">
  import { cn } from '@shared/utils';

  export let isActive = false;
  export let classes = '';
</script>

<p
  class="{cn(
    'bg-default-200 dark:bg-dark-100 flex h-7 w-7  items-center justify-center rounded-full text-base font-medium',
    {
      'text-default-50 dark:text-default-50 border-emerald-600 bg-emerald-600 dark:border-emerald-600 dark:bg-emerald-600':
        isActive,
    },
    classes,
  )}"
>
  <slot name="step" />
</p>

<span class="text-base font-medium"> <slot name="text" /> </span>
